import React from "react";
import WareHouse from "./WareHouse";

const WarehousePage: React.FC = () => <WareHouse />;

export default WarehousePage;
